const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function saveHomeworkState(taskId: number, data: unknown): void {
    localStorage.setItem(`homework_${taskId}`, JSON.stringify({ data, savedAt: Date.now() }));
}

export function loadHomeworkState(taskId: number): unknown | null {
    const raw = localStorage.getItem(`homework_${taskId}`);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!parsed.savedAt || Date.now() - parsed.savedAt > ONE_DAY_MS) {
            localStorage.removeItem(`homework_${taskId}`);
            return null;
        }
        return parsed.data;
    } catch {
        localStorage.removeItem(`homework_${taskId}`);
        return null;
    }
}

export function clearHomeworkState(taskId: number): void {
    localStorage.removeItem(`homework_${taskId}`);
}
